let instance = null

export default class {
  constructor () {
    if (instance) return instance
    instance = this

    this._onResize = this._debounce(() => this.appHeight(), 100)
    this.appHeight()
    window.addEventListener('resize', this._onResize)
  }

  appHeight () {
    document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`)
  }

  _debounce (fn, delay) {
    let timer
    return () => {
      clearTimeout(timer)
      timer = setTimeout(fn, delay)
    }
  }
}
